import { trace } from 'rytm-helpers'
import * as THREE from 'three';
import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry.js'
import { GeometryUtils } from 'three/examples/jsm/utils/GeometryUtils'
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js'
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js'
import { Line2 } from 'three/examples/jsm/lines/Line2.js'
import { getSetup } from "../config";
import soundController from './../controllers/SoundController'

// SETUP object
let setup

class WjShape {
  /**
  * class constructor  
  * @constructor
  **/
  constructor(svg_0, svg_1) {
    setup = getSetup()
    this.vectors_0 = this._svgToVectorPoints(svg_0)
    this.vectors_1 = this._svgToVectorPoints(svg_1)
  }

  getLines() {
    const geometry = this.getLineGeometry()
    const matLine = new LineMaterial( {
      color: setup.shape.LINE_COLOR,
      linewidth: .0008 * setup.shape.LINE_WIDTH_F, // in pixels
    } )
    return new THREE.Line( geometry, matLine )
  }
  
  // getGeometry() {
  //   const positions = this._getGeometryPositions()
  //   const geometry = new THREE.BufferGeometry()
  //   geometry.setAttribute( 'position', positions)
  //   geometry.computeBoundingSphere()
  //   return geometry
  // }
  getLineGeometry() {
    const positions = this._getGeometryPositions()
    const geometry = new LineGeometry()
    geometry.setPositions( positions )
    return geometry
  }
  _getGeometryPositions() {
    const spline = this._getSpline()
    const divisions = Math.round( 12 * (this.vectors_0.length + 1) )
    const positions = []
    const point = new THREE.Vector3()
    for ( let i = 0, l = divisions; i < l; i ++ ) {
      const t = i / l;
      spline.getPoint( t, point );
      // point.setX(point.x + Math.random() * 1 - .5)
      // point.setY(point.y + Math.random() * 1 - .5)
      positions.push( point.x, point.y, point.z )
    }
    return positions
  }
  _getSpline() {
    let vectors
    switch (setup.shape.SHAPE_VECTOR_PASS) {
      case "fade":
        vectors = this._getFrequencyVectorsFade()
        break;
      default:
        vectors = this._getFrequencyVectorsCut()
        break;
    }
    const spline = new THREE.CatmullRomCurve3( [...vectors, vectors[0]] )
    spline.closed = true;
    return spline
  }
  // V3 przejście ostre między v0 a v1
  _getFrequencyVectorsCut() {
    let arr = []
    const soundId = "loop"
    const freqData = soundController.getSoundFrequencyData(soundId)
    const freqPerVector = freqData ? Math.floor(freqData.length / this.vectors_0.length) : 0
    this.vectors_0.forEach((v0, index) => {
      const v1 = this.vectors_1[index]
      const freqIndex = index * freqPerVector
      const freqAverage = freqData ? this._getFrequencyAverage(freqData, freqIndex, freqIndex + freqPerVector) : 0
      const v = new THREE.Vector3(
        freqAverage > setup.shape.FREQUENCY_CUTOFF ? v1.x : v0.x,
        freqAverage > setup.shape.FREQUENCY_CUTOFF ? v1.y : v0.y,
        freqAverage > setup.shape.FREQUENCY_CUTOFF ? v1.z : v0.z,
      )
      arr.push(new THREE.Vector3(
        v.x * (freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_X + setup.shape.SHAPE_MIN_RANGE_X),
        v.y * (freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Y + setup.shape.SHAPE_MIN_RANGE_Y),
        v.z * (freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Z + setup.shape.SHAPE_MIN_RANGE_Z),
      ))
    })
    return arr
  }
  
  // V2 płynne przejście między v0 a v1
  _getFrequencyVectorsFade() {
    let arr = []
    const soundId = "loop"
    const freqData = soundController.getSoundFrequencyData(soundId)
    const freqPerVector = freqData ? Math.floor(freqData.length / this.vectors_0.length) : 0
    this.vectors_0.forEach((v0, index) => {
      const v1 = this.vectors_1[index]
      const freqAverage = freqData ? this._getFrequencyAverage(freqData, index, index + freqPerVector) : 0
      const v = new THREE.Vector3(
        v0.x + (v1.x - v0.x) * freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_X,
        v0.y + (v1.y - v0.y) * freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Y,
        v0.z + (v1.z - v0.z) * freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Z
      )
      arr.push(new THREE.Vector3(
        v.x * (freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_X + setup.shape.SHAPE_MIN_RANGE_X),
        v.y * (freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Y + setup.shape.SHAPE_MIN_RANGE_Y),
        v.z * freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Z + setup.shape.SHAPE_MIN_RANGE_Z,
      ))
    })
    return arr
  }
  /*
  // V1 bez podziału na v0 i v1 (pierwotny koncept)
  _getFrequencyVectors() {
    let arr = []
    const protectedVectorIndexes = [0, Math.floor(this.vectors_0.length * .5)]
    const soundId = "loop"
    const freqData = soundController.getSoundFrequencyData(soundId)
    if (freqData) {
      const freqPerVector = Math.floor(freqData.length / this.vectors_0.length)
      // trace(freqData.length, vectors.length, "freq per vector:", freqPerVector)
      this.vectors_0.forEach((v, index) => {
        const freqAverage = this._getFrequencyAverage(freqData, index, index + freqPerVector)
        const randomCutof = Math.random() * 100 > 100 * setup.shape.RANDOM_CUTOFF ? false : true
        // console.log(randomCutof)
        if ((freqAverage > setup.shape.FREQUENCY_CUTOFF || protectedVectorIndexes.indexOf(index) > -1) && !randomCutof) {
          arr.push(new THREE.Vector3(
            // v.x * freqAverage * setup.shape.SHAPE_DIST_RANGE_X - freqAverage * setup.shape.SHAPE_DIST_RANGE_X * .5,
            // v.y * freqAverage * setup.shape.SHAPE_DIST_RANGE_Y - freqAverage * setup.shape.SHAPE_DIST_RANGE_Y * .5,
            // v.z * freqAverage * setup.shape.SHAPE_DIST_RANGE_Z - freqAverage * setup.shape.SHAPE_DIST_RANGE_Z * .5
            v.x * freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_X,
            v.y * freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Y,
            v.z * freqAverage / 256 * setup.shape.SHAPE_DIST_RANGE_Z
          ))
        }
      })
    } 
    if (arr.length < 2) {
      arr = [vectors[protectedVectorIndexes[0]], vectors[protectedVectorIndexes[1]]]
    }
    return arr
  }
  */
  _getFrequencyAverage(freqData, start, end) {
    let total = 0;
    for (let i = start; i <= end; i++) {
      if (freqData[i]) {
        total += freqData[i];
      }
    }
    return Math.round(total / (end - start))
  }

  // Alternatywa do getLines (tube geometry)
  getThube() {
    const material = new THREE.LineBasicMaterial( { color: setup.shape.LINE_COLOR } )
    // Create Tube Geometry
    const tubeGeometry = new THREE.TubeGeometry(
      new THREE.CatmullRomCurve3([...this.vectors_0, this.vectors_0[0]]),
      this.vectors_0.length,// path segments
      0.01 * setup.shape.LINE_WIDTH_F,// THICKNESS
      5, //Roundness of Tube
      true //closed
    )
    return new THREE.Line(tubeGeometry, material)
  }
  // get Mesh shape...
  getMesh() {
    const spline = this._getSpline()
    const geometry = new ConvexGeometry(spline.points)
    
    const material = new THREE.MeshBasicMaterial({ color: setup.shape.LINE_COLOR});
    return new THREE.Mesh( geometry, material )
  }

  _svgToVectorPoints(svgStr) {
    const div = document.createElement("div")
    div.innerHTML = svgStr
    const svg = div.querySelector("svg")
    div.remove()
    return this._svgCirclesToVectorPoints(svg)
  }
  _svgCirclesToVectorPoints(svg) {
    let arr = []
    const viewBoxStr = svg.getAttribute("viewBox")
    const viewBox = viewBoxStr.split(" ")
    const width = viewBox[2] ? parseInt(viewBox[2]) : 0
    const height = viewBox[3] ? parseInt(viewBox[3]) : 0
    const listCircles = [...svg.querySelectorAll("circle, ellipse, rect")]
    listCircles.forEach((el, index) => {
      const cx = el.getAttribute("cx")
      const cy = el.getAttribute("cy")
      const randomV = new THREE.Vector3(
        Math.random() * setup.shape.SVG_RANDOM_X - setup.shape.SVG_RANDOM_X * .5,
        Math.random() * setup.shape.SVG_RANDOM_Y - setup.shape.SVG_RANDOM_Y * .5,
        Math.random() * setup.shape.SVG_RANDOM_Z - setup.shape.SVG_RANDOM_Z * .5
      )
      const v = new THREE.Vector3(
        (width * .5 - parseInt(cx)) * .1 + randomV.x,
        (height * .5 - parseInt(cy)) * .1 + randomV.y,
        0 + randomV.z
      ) 
      // console.log(myX, myY)
      arr.push(new THREE.Vector3(
        Math.round(v.x), 
        Math.round(v.y), 
        Math.round(v.y)
      ))
    })
    return arr
  }
}

export default WjShape